/**
 * A series' MEANING, as the token it is drawn in — the owner's colour rule for charts (16 September
 * 2026): sleep blue, energy (and mood) ember, everything else neutral ink. Moved here from
 * `pages/client-detail/ui/SurveyChartsStrip.tsx` on 24 September 2026, when the survey task card
 * became its second reader.
 *
 * `--chart-series-record` (lime) is deliberately absent: it belongs to an exercise result, and a
 * survey charts none.
 */

import type { SurveySeriesHue } from '../model/surveyHistory';

export const HUE_INK: Readonly<Record<SurveySeriesHue, string>> = {
  sleep: 'var(--chart-series-sleep)',
  energy: 'var(--chart-series-mood)',
  neutral: 'var(--chart-series-neutral)',
};
